import { useContext, useEffect, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import AppGlobalsContext from "app/AppGlobalsContext";
import { sendTagOnGoogleApiLoad } from "app/utils/analytics";

export default () => {
	const [isGoogleApiReady, setGoogleApiReady] = useState(false);
	const { shop = "", envVars = {} } = useContext(AppGlobalsContext);
	const language = shop.slice(0, 2);

	const { GOOGLE_API_KEY } = envVars;

	useEffect(() => {
		// https://googlemaps.github.io/js-api-loader/index.html
		const loader = new Loader({
			apiKey: GOOGLE_API_KEY,
			version: "weekly",
			libraries: ["places"],
			language: language,
		});

		loader
			.load()
			.then(() => {
				setGoogleApiReady(true);
			})
			.catch(error => {
				setGoogleApiReady(true); // we want to allow the user to enter an address event without the api
				sendTagOnGoogleApiLoad({ error: error.message });
			});
	}, [language, GOOGLE_API_KEY]);

	return isGoogleApiReady;
};
